import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { List } from "./list";
import { Button } from "@progress/kendo-react-buttons";
import { formatDateTime } from "../lib/utils";
import { useTranslation } from "react-i18next";

const scheduleItemRenderer =
  (currentTheme, t, importexport) => (props, item, index) => {
    const handleViewDetails = (e, item, importexport) => {
      props.navigate("/scheduleview/" + item.Id + "?type=" + importexport);
    };

    return (
      <div
        key={item.Id}
        type={importexport}
        className={`list-item`}
        onDoubleClick={(e) => handleViewDetails(e, item, importexport)}
      >
        <div className="list-item-title" style={{ fontWeight: `400` }}>
          <div className="list-detail-title">{item.Name}</div>
          <div className="list-detail-date">
            {item.LastModifiedOn != null
              ? formatDateTime(new Date(item.LastModifiedOn), false)
              : t("schedule.notmodified")}
          </div>
        </div>

        <div className="list-item-action">
          <Button
            disabled={true}
            title={
              importexport == "export"
                ? t("datasetviewer.export")
                : t("datasetviewer.import")
            }
            style={{
              border: "none",
              backgroundColor: "transparent",
            }}
            icon={importexport == "export" ? "export" : "import"}
          ></Button>
        </div>

        <div className="list-item-health list-item-action">
          <Button
            disabled={false}
            style={{
              border: "none",
              color: item.IsActive
                ? `${currentTheme.warning}`
                : `${currentTheme.success}`,
              backgroundColor: "transparent",
            }}
            icon={item.IsActive ? "pause" : "play"}
            onClick={(e) => {
              item.IsActive
                ? props.handlePauseSchedule(e, item)
                : props.handleResumeSchedule(e, item);
            }}
          ></Button>
        </div>

        <div className="list-item-view list-item-action">
          {props.canView && (
            <Button
              disabled={false}
              title={t("datasetviewer.view")}
              style={{
                border: "none",
                color: currentTheme.touchColor,
                backgroundColor: "transparent",
              }}
              icon="eye"
              onClick={(e) => handleViewDetails(e, item, importexport)}
            ></Button>
          )}
        </div>

        <div className="list-item-delete list-item-action">
          {props.canDelete && (
            <Button
              disabled={false}
              title={t("datasetviewer.delete")}
              style={{
                border: "none",
                color: currentTheme.error,
                backgroundColor: "transparent",
              }}
              icon="delete"
              onClick={(e) => props.onDelete(e, item)}
            ></Button>
          )}
        </div>
      </div>
    );
  };

export const ScheduleExportsViewer = (props) => {
  const {
    canView,
    canCreate,
    canEdit,
    canDelete,
    onDelete,
    handlePauseSchedule,
    handleResumeSchedule,
    //onImport,
    onSetFavorite,
    ...other
  } = props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.scheduleLocatorPage);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const filter = pageState.filter;
  const showSystemEntities = pageState.showSystemEntities;

  const filteredItems = pageState.exports?.filter((e) => {
    if ((!filter || filter.trim() == "") && showSystemEntities) return true;

    if (!filter || filter.trim() == "")
      //do not show system entities
      return e.IsSystem == false;

    //i am here => there is text
    const trimmedFilter = filter.toLowerCase();

    if (showSystemEntities)
      return e.Title.toLowerCase().indexOf(trimmedFilter) >= 0;
    else
      return (
        e.Title.toLowerCase().indexOf(trimmedFilter) >= 0 && e.IsSystem == false
      );
  });

  return (
    <Fragment>
      <div className={"schedule-viewer"}>
        <div className="header-list">
          <div className="header-left">{t("schedule.title")}</div>
          <div className="header-right">{t("schedule.lastModified")}</div>
        </div>
        {filteredItems?.length > 0 && (
          <List
            className="schedule-viewer-list"
            navigate={navigate}
            items={filteredItems}
            onSetFavorite={onSetFavorite}
            canView={canView}
            canCreate={canCreate}
            canEdit={canEdit}
            canDelete={canDelete}
            onDelete={onDelete}
            handlePauseSchedule={handlePauseSchedule}
            handleResumeSchedule={handleResumeSchedule}
            itemRenderer={scheduleItemRenderer(currentTheme, t, "export")}
          />
        )}
      </div>
      <style>
        {`
                    .schedule-viewer
                    {
                        width: 100%;
                        // height: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: flex-start;
                        align-content: start;
                        flex: 1;
                        overflow: auto;
                        padding: 0 26px;
                    }
                        
                    .schedule-viewer .header-list{
                      display:flex;
                      justify-content:space-between;
                      width:calc(100% - 146px);
                      padding:12px;
                      font-weight:bold;
                    }

                    .schedulelocator-page .schedule-viewer .schedule-viewer-list
                    {
                        border: 1px dotted ${currentTheme.separatorColor}; 
                        border-radius: 8px;
                        min-width: 700px;
                        width: 100%;
                        height: calc(100% - 130px);
                        display:table;
                        padding: 0px 0px 0px 0px;
                        overflow-y:auto;
                    }

                    .schedulelocator-page .schedule-viewer .schedule-viewer-list .list-root
                    {
                        border-collapse: collapse;
                    }

                    .schedulelocator-page .schedule-viewer .schedule-viewer-list .list-item
                    {
                        line-height: 3;
                        border-top: 1px solid ${currentTheme.componentBorderColor}; 
                        border-radius: 6px;
                    }

                    .schedulelocator-page .schedule-viewer .schedule-viewer-list .list-item:first-child
                    {
                        border-top: none;
                    }

                    .schedulelocator-page .schedule-viewer .schedule-viewer-list .list-item:last-child
                    {
                        border-bottom: 1px solid ${currentTheme.componentBorderColor}; 
                    }

                    .schedulelocator-page .schedule-viewer .schedule-viewer-list .list-item:hover
                    {
                      background-color: ${currentTheme.componentBorderColor};
                      cursor: pointer;
                    }

                    .schedulelocator-page .schedule-viewer .schedule-viewer-list .list-item-title,
                    .schedulelocator-page .schedule-viewer .schedule-viewer-list .list-item-system
                    {
                        width: 100%;
                        vertical-align: middle;
                        padding-left: 12px;
                        display:flex;
                        justify-content:space-between;
                    }

                    .schedulelocator-page .schedule-viewer .schedule-viewer-list .list-item-action{
                        width:30px;
                    }

                    @media (max-width: 1024px) {
                      .schedulelocator-mobile-view .schedule-viewer {
                        height: auto;
                        padding: 0;
                        overflow: visible;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .header-list {
                        display: none;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .schedule-viewer-list {
                        min-width: 0;
                        height: auto;
                        border: none;
                        border-radius: 0;
                        display: block;
                        overflow: visible;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .schedule-viewer-list .list-root {
                        display: block;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .schedule-viewer-list .list-item {
                        display: flex;
                        align-items: flex-start;
                        padding: 12px 0;
                        border-top: none;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                        line-height: normal;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .schedule-viewer-list .list-item > div {
                        display: flex;
                        padding: 0;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .schedule-viewer-list .list-item-title {
                        flex: 1;
                        min-width: 0;
                        flex-direction: column;
                        gap: 6px;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .schedule-viewer-list .list-detail-title {
                        overflow-wrap: anywhere;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .schedule-viewer-list .list-detail-date {
                        font-size: 12px;
                        opacity: 0.75;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .schedule-viewer-list .list-item-action {
                        flex: 0 0 auto;
                        width: auto;
                        margin-inline-start: 4px;
                      }

                      .schedulelocator-mobile-view .schedule-viewer .schedule-viewer-list .list-item-delete {
                        display: none !important;
                      }
                    }
                    
                    `}
      </style>
    </Fragment>
  );
};

export const ScheduleImportsViewer = (props) => {
  const {
    canView,
    canCreate,
    canEdit,
    canDelete,
    onDelete,
    handlePauseSchedule,
    handleResumeSchedule,
    //onImport,
    onSetFavorite,
    ...other
  } = props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.scheduleLocatorPage);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const filter = pageState.filter;
  const showSystemEntities = pageState.showSystemEntities;

  const filteredItems = pageState.imports?.filter((e) => {
    if ((!filter || filter.trim() == "") && showSystemEntities) return true;

    if (!filter || filter.trim() == "")
      //do not show system entities
      return e.IsSystem == false;

    //i am here => there is text
    const trimmedFilter = filter.toLowerCase();

    if (showSystemEntities)
      return e.Title.toLowerCase().indexOf(trimmedFilter) >= 0;
    else
      return (
        e.Title.toLowerCase().indexOf(trimmedFilter) >= 0 && e.IsSystem == false
      );
  });

  return (
    <Fragment>
      <div className={"schedule-viewer"}>
        {filteredItems?.length > 0 && (
          <List
            className="schedule-viewer-list"
            navigate={navigate}
            items={filteredItems}
            onSetFavorite={onSetFavorite}
            canView={canView}
            canCreate={canCreate}
            canEdit={canEdit}
            canDelete={canDelete}
            onDelete={onDelete}
            handlePauseSchedule={handlePauseSchedule}
            handleResumeSchedule={handleResumeSchedule}
            //onImport={onImport}
            itemRenderer={scheduleItemRenderer(currentTheme, t, "import")}
          />
        )}
      </div>
    </Fragment>
  );
};
